<template>
  <div class="modal-content-event">
    <div class="modal-header">
      <h2>Izmena opisa događaja</h2>
    </div>
    <div class="body">
      <form action="post">
        <div id="first-section">
          <div id="description-area">
            <label class="col-form-label col-form-label-lg">Opis</label>
            <textarea
              class="form-control"
              rows="4"
              placeholder="Unesite opis"
              v-model.trim="event.body"
              @focus="errorOccurred = false"
            ></textarea>
          </div>
          <div id="upload-area">
            <label class="col-form-label col-form-label-lg">Datoteke</label>
            <div id="uploaded-files">
              <div
                id="empty-files"
                v-if="event.medias == null || event.medias.length === 0"
              >
                <p>Nemate dodatih datoteka</p>
              </div>
              <div
                class="file"
                v-for="(file, index) of event.medias"
                :key="index"
              >
                <p>{{ file.file_name }}</p>
              </div>
            </div>
          </div>
        </div>

        <div id="map-area">
          <div class="map">
            <gmap-map
              ref="mapRef"
              :center="mapCenter"
              :zoom="13"
              map-type-id="roadmap"
              style="width: 100%; height: 300px"
            >
              <gmap-marker
                ref="marker"
                :position="mapCenter"
                :animation="4"
                :clickable="true"
                :draggable="false"
                :opacity="0.8"
                :icon="{
                  url: require('../../../assets/marker.png')
                }"
              ></gmap-marker>
            </gmap-map>
          </div>
          <div class="map-desc">
            <div class="form-group row">
              <label for="chosenPlace" class="col-sm-2 col-form-label"
                >Izabrano:</label
              >
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="event.location"
                  class="form-control"
                  id="chosenPlace"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
        <div id="date-area">
          <div class="date">
            <input
              type="text"
              :value="dateFrom"
              class="form-control"
              style="margin-right: 2px"
              disabled
            />
          </div>
          <div class="date">
            <input
              type="text"
              :value="dateTo"
              class="form-control"
              style="margin-left: 2px"
              disabled
            />
          </div>
        </div>
      </form>
      <span class="txt-pin">Pinovana objava</span>
      <checkbox
        size="small"
        :checked="event.is_pinned == '1'"
        @change.native="togglePin()"
      ></checkbox>
    </div>

    <hr />
    <div class="footer">
      <div class="error">
        <transition enter-active-class="animated shake">
          <p class="err-msg" v-if="errorOccurred">{{ errorMessage }}</p>
        </transition>
      </div>

      <div class="buttons" style="text-align:center">
        <button
          type="submit"
          class="btn btn-danger btn--mod"
          @click="closeModal"
        >
          Otkaži
        </button>
        <button
          type="submit"
          class="btn btn-primary btn--mod"
          @click="editEvent"
          :disabled="loading"
        >
          <span v-if="!loading">Potvrdi</span>
          <spinner line-fg-color="#00796b" v-if="loading" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import 'vue-datetime/dist/vue-datetime.css';
import axios from '@/axios/axios.js';
import { formatDateMixin } from '@/mixins/mixins.js';
import { Settings, DateTime } from 'luxon';
import checkbox from '@/components/common/Checkbox.vue';

export default {
  components: {
    checkbox
  },
  data() {
    return {
      errorOccurred: false,
      errorMessage: ''
    };
  },
  computed: {
    ...mapState(['loading']),
    ...mapState('modal', ['event']),
    mapCenter() {
      return {
        lat: Number(this.event.locationGpsLat),
        lng: Number(this.event.locationGpsLong)
      };
    },
    dateFrom() {
      return 'Od: ' + this.event.dateFrom;
    },
    dateTo() {
      return 'Do: ' + this.event.dateTo;
    }
  },
  mixins: [formatDateMixin],
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal']),
    ...mapMutations(['setPostTitle']),
    ...mapActions('table', ['getEventsByCommunity']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    togglePin() {
      if (this.event.is_pinned == '1') {
        this.event.is_pinned = '0';
      } else {
        this.event.is_pinned = '1';
      }
    },
    validateInput() {
      if (this.event.body === '') {
        this.errorOccurred = true;
        this.errorMessage = 'Morate uneti opis događaja';
        return false;
      }
      return true;
    },
    editEvent() {
      if (!this.validateInput()) {
        return;
      }
      let postData = {
        body: this.event.body,
        post_id: this.event.postId,
        media_ids: this.event.medias.map(e => e.id)
      };

      this.loadingStarted();

      axios
        .post('/post/edit', postData)
        .then(async () => {
          try {
            await axios.post('/post/pin', {
              member_id: this.$store.getters.getActiveCommunity.member_id,
              post_id: this.event.postId,
              pin: this.event.is_pinned == '1' ? true : false
            });
          } catch (error) {
            console.log(error);
            this.showFailModal();
            this.loadingFinished();
          }
          this.loadingFinished();
          this.getEventsByCommunity(this.$store.getters.getActiveCommunity.id);
          // this.setPostTitle(this.event.body);
          this.setPostTitle('Događaj');
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(error => {
          this.loadingFinished();
          console.log(error);
          this.showFailModal();
        });
    }
  }
};
</script>

<style lang="scss">
.modal-content-event {
  .body {
    height: 100%;
    width: 100%;
  }

  input.vdatetime-input.form-control.form-control-lg {
    font-size: 1rem !important;
  }
  input {
    margin-bottom: 5px;
    position: relative;
  }
  #first-section {
    display: inline-flex;
    height: 100%;
    width: 100%;
  }

  #date-area {
    display: inline-flex;
    height: 100%;
    width: 100%;
  }

  .date {
    width: 50%;
  }

  textarea.form-control {
    resize: none;
    width: 100%;
  }

  #description-area {
    width: 66%;
  }

  #upload-area {
    display: block;
    margin-left: 9px;
    width: 34%;
    height: 100%;
  }

  #uploaded-files {
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    height: 110px;
    resize: none;
    max-height: 134px;
    overflow-y: auto;
    padding: 5px;
  }

  .minus--mod {
    margin-left: 5px;
    font-size: 17px;
    color: grey;
    transition: color 0.25s;
  }

  .minus--mod:hover {
    cursor: pointer;
    color: #ff837b;
  }

  .footer {
    display: block;
    width: 100%;
    text-align: center;
  }
  .buttons {
    display: inline-flex;
    float: right;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .btn-primary:hover {
    background-color: var(--primary-color-lighten);
  }

  .btn-primary:active {
    background-color: var(--primary-color) !important;
    border: none;
  }

  .btn-primary:focus {
    box-shadow: 0 0 0 0.2rem var(--primary-color-lighten) !important;
  }

  .error {
    float: left;
    margin-left: 15px;
  }

  .err-msg {
    text-align: center;
    color: red;
  }

  #add-file-label {
    display: inline-flex;
  }

  #add-file-label:hover {
    display: inline-flex;
    cursor: pointer;
    color: var(--primary-color);
    transition: color 0.25s;
  }

  .del--mod {
    margin-left: auto;
    /*margin-right: 0;*/
    cursor: pointer;
    color: red;
    top: 4.7em;
    right: 1.7em;
  }

  #empty-files {
    text-align: center;
    color: grey;
    margin-top: 15%;
  }

  .col-form-label-lg {
    width: 100%;
    position: relative;
  }

  .btn--mod {
    margin-left: 15px;
  }

  .file {
    border-bottom: solid 1px lightgray;
    font-size: 15px;
    width: 100%;
    display: inline-flex;
    vertical-align: center;
    p {
      max-width: 155px;
      word-wrap: break-word;
      margin-bottom: 2px;
    }
  }

  .vdatetime-calendar__month__day--selected > span > span,
  .vdatetime-calendar__month__day--selected:hover > span > span {
    background: var(--primary-color);
  }

  .vdatetime-popup__actions__button {
    color: var(--primary-color);
  }

  .vdatetime-time-picker__item--selected {
    color: var(--primary-color);
  }

  .vdatetime-popup__header {
    background: var(--primary-color);
  }

  #map-area {
    margin-top: 5px;
  }

  .map {
    margin-bottom: 5px;
  }

  #chosenPlace.form-control {
    width: 100%;
  }
  .user-notif {
    margin-bottom: 0px;
  }

  .form-group.row {
    margin-bottom: 0px;
  }

  .col-sm-10 {
    padding-right: 0px;
  }
}
</style>
